var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import Vue from "vue";
var Component = /** @class */ (function (_super) {
    __extends(Component, _super);
    function Component() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return Component;
}(Vue));
export { Component };
/**
 * Create component from component options (Compatible with Vue.extend)
 */
export function createComponent(opts) {
    return Vue.extend(opts);
}
var factoryImpl = {
    convert: function (c) { return c; },
    extendFrom: function (c) { return c; }
};
/**
 * Specify Props and Event types of component
 *
 * Usage:
 *  // Get TSX-supported component with props(`name`, `value`) and event(`onInput`)
 *  const NewComponent = tsx.ofType<{ name: string, value: string }, { onInput: string }>.convert(Component);
 */
export function ofType() {
    return factoryImpl;
}
export function withNativeOn(componentType) {
    return componentType;
}
export function withHtmlAttrs(componentType) {
    return componentType;
}
export function withUnknownProps(componentType) {
    return componentType;
}
export function withPropsObject(componentType) {
    return componentType;
}
function createComponentFactory(base, mixins) {
    return {
        create: function (options) {
            var mergedMixins = options.mixins ? __spreadArrays(options.mixins, mixins) : mixins;
            return base.extend(__assign(__assign({}, options), { mixins: mergedMixins }));
        },
        mixin: function (mixinObject) {
            return createComponentFactory(base, __spreadArrays(mixins, [mixinObject]));
        }
    };
}
function createExtendableComponentFactory() {
    return {
        create: function (options) {
            return Vue.extend(options);
        },
        extendFrom: function (base) {
            return createComponentFactory(base, []);
        },
        mixin: function (mixinObject) {
            return createComponentFactory(Vue, [mixinObject]);
        }
    };
}
export var componentFactory = createExtendableComponentFactory();
export function componentFactoryOf() {
    return componentFactory;
}
/**
 * Shorthand of `componentFactory.create`
 */
export var component = componentFactory.create;
export var extendFrom = componentFactory.extendFrom;
export function emit(vm, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    vm.$emit.apply(vm, __spreadArrays([name], args));
}
export function emitOn(vm, name) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    vm.$emit.apply(vm, __spreadArrays([name.replace(/^on[A-Z]/, function (v) { return v[2].toLowerCase(); })], args));
}
export function emitUpdate(vm, name, value) {
    vm.$emit("update:" + name, value);
}
//# sourceMappingURL=data:application/json;base64,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